export enum QueryKey {
  categories = 'categories',
  menuPromotionItems = 'menuPromotionItems',
  deliveryAddresses = 'deliveryAddresses',
  invoiceAddresses = 'invoiceAddresses',
  authUser = 'authUser',
  banners = 'banners',
  mostBought = 'mostBought',
  upselling = 'upselling',
  ribbon = 'ribbon',
  marketingPopover = 'marketingPopover',
  fetchUpsellingSection = 'fetchUpsellingSection',
  rebateCodes = 'rebateCodes',
  recommendedProducts = 'recommendedProducts',
  deliveryCitiesForPostalCode = 'deliveryCitiesForPostalCode',
  recommendedPersonalizedProducts = 'recommendedPersonalizedProducts',
  recommendedSingleItemProducts = 'recommendedSingleItemProducts',
  packingOptions = 'packingOptions',
  recommendedCartProducts = 'recommendedCartProducts',
  deliverySlots = 'deliverySlots',
  deliveryMethod = 'deliveryMethod',
  rewardsProgram = 'rewardsProgram',
  profileOrders = 'profileOrders',
  makedOrder = 'makedOrder',
  searchProducts = 'searchProducts'
}
